import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  keywordsSection: {
    marginTop: 16
  },
  excludeKeywordsTitle: {
    marginTop: 16
  }
})

export default useStyles
